import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bs-page-header" }
const _hoisted_2 = { class: "bs-page-header__main" }
const _hoisted_3 = { class: "bs-page-header__additional" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bs_page_title = _resolveComponent("bs-page-title")!
  const _component_bs_page_description = _resolveComponent("bs-page-description")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (Boolean(_ctx.$slots['title']))
        ? (_openBlock(), _createBlock(_component_bs_page_title, { key: 0 }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "title")
            ]),
            _: 3
          }))
        : _createCommentVNode("", true),
      (Boolean(_ctx.$slots['description']))
        ? (_openBlock(), _createBlock(_component_bs_page_description, { key: 1 }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "description")
            ]),
            _: 3
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "additional")
    ])
  ]))
}